import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { MainPageLogicComponent } from './main-page-logic/main-page-logic.component';
import { AppRoutingModule } from './app-routing.module';
import { BrandingLayoutModule } from './core/layout/branding-layout.module';
import { PlanSelectionComponent } from './plan-selection/plan-selection.component';
import { MediaPlanSelectionComponent } from './media-plan-selection/media-plan-selection.component';

import { HttpClientModule } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { NavigationPositionBarComponent } from './main-page-logic/navigation/navigation-position-bar/navigation-position-bar.component';
import { AccessibilityComponent } from './core/layout/accessibility/accessibility.component';
import { FaqComponent } from './core/layout/faq/faq.component';

import { ContractCompletionPage } from './confirmation-page/confirmation-page.component';
import { TermsComponent } from './core/layout/terms/terms.component';
import { PrivacyComponent } from './core/layout/privacy/privacy.component';
import { PageTermDetailsComponent } from './core/layout/page-term-details/page-term-details.component';
import { MatDialogModule } from '@angular/material/dialog';
import { switchMap } from 'rxjs';
import { BootstrapErrorComponent } from './main-page-logic/bootstrap-error/bootstrap-error.component';

import { LayoutChangeService } from './shared/layout-change.service';
import { FormNavigationControlsComponent } from './main-page-logic/navigation/form-navigation-controls/form-navigation-controls.component';


@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        HttpClientModule,
        BrowserModule,
        AppRoutingModule,
        BrandingLayoutModule,
        MainPageLogicComponent,
        PlanSelectionComponent,
        NavigationPositionBarComponent,
        AccessibilityComponent,
        FaqComponent,
        TermsComponent,
        PrivacyComponent,
        PageTermDetailsComponent,
        ContractCompletionPage,
        MediaPlanSelectionComponent,
        MatDialogModule,
        BootstrapErrorComponent,
        FormNavigationControlsComponent
    ],
    providers: [
        LayoutChangeService,
        //might need to add other services here and make some of them injectable, 
        //could be an actual improvement later on. -AG
    ],
    bootstrap: [AppComponent]
})
export class AppModule { 

    promo: string = '';

    constructor(
        private readonly route: ActivatedRoute
    ) {
        let stop = "stop";

        let obs$ = this.route.paramMap.pipe(
            switchMap(params => {
              this.promo = params.get('promo') || '';
              return this.promo;
            })
        );
    }

}
